/**
 * Sanitize an object from the API by converting "NULL" strings to null.
 * SQL Server / API sometimes returns the literal string "NULL" instead of actual null.
 * Combined with `?? ""` on TextField values, this ensures fields show empty instead of "NULL".
 */
export const sanitizeNullStrings = <T>(data: T): T => {
	const result = { ...data } as any;
	for (const key in result) {
		if (result[key] === "NULL") {
			result[key] = null;
		}
	}
	return result as T;
};
